export class MapObject {

    constructor(public id:number, public longitude:number, public latitude:number, public label:String) {}

}


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/src/app/shared/data/map-object.ts